module.exports = __webpack_public_path__ + "img/984.aea2062a.png";